const popup = document.querySelector('.custom-popup');
if (popup) {
    const delaySeconds = parseInt(popup.getAttribute('data-popup-delay'), 10) || 0; // Ensure delay is a number
    const closePopupBtns = popup.querySelectorAll('.custom-popup-close');

    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const hasVisitedCookie = document.cookie.indexOf('visited=true') !== -1;

    if (isLocalhost || !hasVisitedCookie) {
        // Set cookie for 15 days (only if not on localhost)
        if (!isLocalhost) {
            const fifteenDays = 1000 * 60 * 60 * 24 * 15;
            const expires = new Date(Date.now() + fifteenDays).toUTCString();
            document.cookie = "visited=true;expires=" + expires + ";path=/";
        }

        // Open popup after delay
        const openPopup = () => {
            popup.classList.add('open');
        };

        // Close popup when close buttons are clicked
        closePopupBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                popup.classList.remove('open');
            });
        });

        // Wait for DOM to load and delay the popup
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(openPopup, delaySeconds * 1000);
        });
    }
}